// src/assets/images/HomeFeatures/imageMapping.js

// Feature images
import feature1 from './feature-1.webp';
import feature2 from './feature-2.webp';
import feature3 from './feature-3.webp';
import feature4 from './feature-4.webp';
import feature5 from './feature-5.webp';
import feature6 from './feature-6.webp';
import feature7 from './feature-7.webp';
import feature8 from './feature-8.webp';

// Icon images
import navegacionAgricultura     from './navegacion-agricultura.webp';
import navegacionConcreto        from './navegacion-concreto.webp';
import navegacionMovimientoTierras from './navegacion-movimiento-de-tierras.webp';
import navegacionMineria         from './navegacion-mineria.webp';
import navegacionMontacargas     from './navegacion-montacargas.webp';
import navegacionElevacion       from './navegacion-elevacion.webp';
import navegacionGruasMoviles    from './navegacion-gruas-moviles.webp';
import navegacionGruasTorre      from './navegacion-gruas-torre.webp';

export const imageMapping = {
  // feature images
  'feature-1.webp': feature1,
  'feature-2.webp': feature2,
  'feature-3.webp': feature3,
  'feature-4.webp': feature4,
  'feature-5.webp': feature5,
  'feature-6.webp': feature6,
  'feature-7.webp': feature7,
  'feature-8.webp': feature8,

  // icon images
  'icon-1.webp': navegacionAgricultura,
  'icon-2.webp': navegacionConcreto,
  'icon-3.webp': navegacionMovimientoTierras,
  'icon-4.webp': navegacionMineria,
  'icon-5.webp': navegacionMontacargas,
  'icon-6.webp': navegacionElevacion,
  'icon-7.webp': navegacionGruasMoviles,
  'icon-8.webp': navegacionGruasTorre,
};
